import React, { useRef } from 'react';
import { Field } from 'formik';
import { func, string } from 'prop-types';

const empty = Symbol('empty');

const FieldSpy = ({ name, onChange }) => {
  const value = useRef(empty);

  return (
    <Field name={name}>
      {({ field }) => {
        if (value.current !== empty && value.current !== field.value) {
          onChange(field.value);
        }
        value.current = field.value;

        return null;
      }}
    </Field>
  );
};

FieldSpy.propTypes = {
  name: string.isRequired,
  onChange: func.isRequired,
};

export default FieldSpy;


// WEBPACK FOOTER //
// ./src/components/formik/FieldSpy.jsx